// This file was automatically generated from appchart.dialog.deleteChart.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.deleteChart');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.deleteChart.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pad10"><p class="el8Spacer el8EmphasisText">Are you sure that you want to delete this chart?</p><p class="el8AppText el8Spacer5">This chart and all of its content (documents, messages, orders, etc.) will be <span class="el8Bold">deleted</span>. Once the chart has been deleted, you will be redirected to the practice homepage.</p></div>');
  if (!opt_sb) return output.toString();
};
